import Navbar from "./Navbar";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-dulia-parchment text-dulia-ink transition-colors dark:bg-dulia-night dark:text-dulia-parchment">
      <Navbar />
      <main className="mx-auto w-full max-w-6xl py-8 md:px-6 lg:py-10">
        {children}
      </main>
    </div>
  );
}